import React from 'react'

import SanitizedHtml from '@/components/misc/SanitizedHtml'
import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  html: string
}

const HtmlContent: React.FC<Props> = ({ html, className, ...props }) => (
  <SanitizedHtml
    html={html}
    className={cn('prose text-body-base font-light', className)}
    {...props}
  />
)

export default HtmlContent
